var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBodyStructure5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 96,
    viewBox: "0 0 110 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.5625 72.6997H54.1876C42.2399 72.6997 30.7815 67.958 22.3332 59.5177C13.8849 51.0774 9.13874 39.6298 9.13874 27.6934L9.13874 6.13347C9.13874 4.73034 9.69666 3.38467 10.6898 2.3925C11.6829 1.40034 13.0298 0.842949 14.4343 0.842949L96.3158 0.842949C97.7203 0.842949 99.0672 1.40034 100.06 2.3925C101.053 3.38467 101.611 4.73034 101.611 6.13347V27.6934C101.611 39.6298 96.8651 51.0774 88.4168 59.5177C79.9685 67.958 68.5102 72.6997 56.5625 72.6997V72.6997Z",
    fill: "#3098F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.978 95.9243H4.75787C4.12564 95.9289 3.50108 95.7858 2.93405 95.5064C2.36701 95.227 1.8732 94.819 1.49202 94.3151C1.11083 93.8112 0.852838 93.2252 0.738619 92.6039C0.624399 91.9827 0.657118 91.3433 0.834165 90.7369L7.25075 67.158C7.90504 64.6264 9.38317 62.3838 11.4526 60.7832C13.5221 59.1825 16.0654 58.3146 18.6826 58.3159H92.0382C94.6579 58.3113 97.2046 59.1778 99.2771 60.7787C101.35 62.3796 102.83 64.6239 103.485 67.158L109.842 90.7369C110.015 91.3384 110.046 91.9715 109.934 92.587C109.821 93.2026 109.568 93.7839 109.194 94.2858C108.821 94.7877 108.336 95.1966 107.778 95.4808C107.22 95.765 106.604 95.9168 105.978 95.9243Z",
    fill: "#3098F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodyStructure5);
export default __webpack_public_path__ + "static/media/body-structure5.484c9ee61f2dd96bc7f894e910dd4e17.svg";
export { ForwardRef as ReactComponent };